import { Injectable } from '@angular/core';
import {LoaderService} from "./loader.service";
import {Observable} from "rxjs/Observable";
import {IResourceMetrics} from "../interfaces/resource-metrics.definition";


@Injectable()
export class ResourceMetricsService extends LoaderService {
  loadMetrics(resourceId: number): Observable<IResourceMetrics> {
    const body = { resourceId };
    return this.sendPost("/api/resource-metrics", body)
      .map(r => <IResourceMetrics>r.json());
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/services/resource-metrics.service.ts